import './style/HomeComponent.css'; 
import { useMediaQuery } from 'react-responsive';
import React, { useRef, useState, useEffect, useContext } from 'react';
import './style/ScrollGallery.css'; // Styles in separate file
import icon from './image/colorix_affiche.jpg'; 
import icon2 from './image/colorix_flyers.jpg'; 
import icon3 from './image/colorix_calendriers.jpg';
import icon4 from './image/colorix_kakemono-x-banner.jpg';
import icon5 from './image/colorix_roll-up.jpg';
import icon6 from './image/colorix_tasses-mug.jpg';
import icon7 from './image/colorix_magazine_ouvert.jpg';
import icon8 from './image/colorix_depliant_1.jpg';
import icon9 from './image/colorix_bouquin_graike.jpg';
import icon10 from './image/colorix_shopping_bag.jpg';
import icon11 from './image/colorix_depliant_2.jpg';
import icon12 from './image/colorix_brochures2.jpg';
import icon13 from './image/CloudStorage.png';
import icon14 from './image/partner3.png';
import icon16 from './image/partner6.jpg';
import icon15 from './image/partner8.jpg';
import icon17 from './image/banner2.png';
import icon18 from './image/hotl.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ForeGroundContext } from './ForeGroundContext';
import { Carousel } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import axios from 'axios';




const HomeComponent = ({ isMenuVisible }) => {

  const [loading, setLoading] = useState(true)
  /*const [films, setFilms]= useState([])
  useEffect(() => {
    moviesRequest()
  }, [])
  const moviesRequest = async()=>{
    await axios.get(`${process.env.REACT_APP_BACKEND_URL}films`).then(
      (res)=> {
        
        setFilms(res.data.films)
        setLoading(false)
        console.log(res)
      }
    )
  };*/
  const [images, setImages] = useState([]);
  const [contentArray, setContentArray] = useState([]);
  const [services, setServices] = useState([]);
  const [missions, setMission] = useState([]);
  const [hotlines, setHotline] = useState([]); 
  const [products, setProduct] = useState([]); 
  const [categories, setCategories] = useState([]); 
  const [classiques, setClassique] = useState([]); 
  const [celebrations,  setCelebrations] = useState([]);
  const [cadeaux, setCadeaux] = useState([]); 
  const [servicestitle, setServicestitle] = useState(null);

  const [data, setData] = useState([]);
/*
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('fr')) {
    useEffect(() => {

      const cachedImagesfr = JSON.parse(localStorage.getItem('imagesfr'));
      const cachedtextsfr = JSON.parse(localStorage.getItem('extractedTextsfr'));
      
      if (cachedImagesfr && cachedtextsfr) {
        // If images are found in localStorage, use them
        setImages(cachedImagesfr);
       setContentArray(cachedtextsfr);
      } else {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}homefr`)
      .then(response => {
        const urls = response.data.map(item =>
          `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`
        );
        const extractedTexts = response.data.map(item => {
          try {
            return JSON.parse(item.value).text + '</br></br><button style="border-radius:5px;">en savoir plus</button>';
          } catch (e) {
            console.error('Failed to parse value:', item.value);
            return '';
          }
        });
        setImages(urls);
        setContentArray(extractedTexts);
        //setData(response.data);
        localStorage.setItem('imagesfr', JSON.stringify(urls));
        localStorage.setItem('extractedTextsfr', JSON.stringify(extractedTexts));
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    }
    }, []);
  } else {

  useEffect(() => {

    const cachedImagesen = JSON.parse(localStorage.getItem('images'));
    const cachedtextsen = JSON.parse(localStorage.getItem('extractedTexts'));
    
    if (cachedImagesen && cachedtextsen) {
      // If images are found in localStorage, use them
      setImages(cachedImagesen);
      setContentArray(cachedtextsen);
    } else {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}homeen`)
    .then(response => {
      const urls = response.data.map(item =>
        `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`
      );
      const extractedTexts = response.data.map(item => {
        try {
          return JSON.parse(item.value).text + '</br></br><button style="border-radius:5px;">learn more</button>';
        } catch (e) {
          console.error('Failed to parse value:', item.value);
          return '';
        }
      });
      setImages(urls);
      setContentArray(extractedTexts);
      //setData(response.data);
      localStorage.setItem('imagesen', JSON.stringify(urls));
      localStorage.setItem('extractedTextsen', JSON.stringify(extractedTexts));
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  }
}, []);

  }*/

  const { language } = useLanguage();


useEffect(() => {
  if (language === 'FR') {
   
 
  const cachedImagesfre = JSON.parse(localStorage.getItem('imagesfre'));
  const cachedtextsfre = JSON.parse(localStorage.getItem('extractedTextsfre'));
  const cachedservicefre = JSON.parse(localStorage.getItem('servicefre'));
  const cachedMissionfre = JSON.parse(localStorage.getItem('Missionfre'));
  const cachedHotlinefre = JSON.parse(localStorage.getItem('Hotlinefre')); 
  const cachedProductfre = JSON.parse(localStorage.getItem('Productfre'));
  const cachedCelebrationsfre = JSON.parse(localStorage.getItem('Celebrationsfre'));
  const cachedCadeauxfre = JSON.parse(localStorage.getItem('Cadeauxfre')); 
  const cachedServicetitlefre = JSON.parse(localStorage.getItem('Servicetitlefre')); 
  const cachedCategoriesfre = JSON.parse(localStorage.getItem('Categoriesfre'));  
  const cachedClassiquesfre = JSON.parse(localStorage.getItem('Classiquesfre')); 
  
  if (cachedImagesfre && cachedtextsfre && cachedservicefre && cachedMissionfre && cachedHotlinefre && cachedProductfre && cachedCelebrationsfre && cachedCadeauxfre && cachedServicetitlefre && cachedCategoriesfre && cachedClassiquesfre) {
    // If images are found in localStorage, use them
    setImages(cachedImagesfre);
   setContentArray(cachedtextsfre);
   setServices(cachedservicefre);
   setMission(cachedMissionfre);
   setHotline(cachedHotlinefre);  
   setProduct(cachedProductfre);
   setCategories(cachedCategoriesfre);
   setClassique(cachedClassiquesfre);
   setCelebrations(cachedCelebrationsfre);
   setCadeaux(cachedCadeauxfre);
   setServicestitle(cachedServicetitlefre);
  } else { 
  axios.get(`${process.env.REACT_APP_BACKEND_URL}homefr`)
  .then(response => {

    // Filter only items where page_group === 'Diapositiv'
    const diapositivItems = response.data.filter(item => item.page_group === 'Diapositiv');

    const urls = diapositivItems.map(item =>
      `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`
    );
    const extractedTexts = diapositivItems.map(item => {
      try {
        return JSON.parse(item.value).text + '</br></br><button style="border-radius:5px;">en savoir plus</button>';
      } catch (e) {
        console.error('Failed to parse value:', item.value);
        return '';
      }
    });
    setImages(urls);
    setContentArray(extractedTexts);


    // Filter for only page_group === "Service"
    const MissionItems = response.data.filter(item => item.page_group === "Mission");

    // Parse the JSON value string and return usable data
    const parsedMission = MissionItems.map(item => {
      let parsedMissionValue = {};
      try {
        parsedMissionValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        image: `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`,
        title: item.page_part,
        titel_1: parsedMissionValue.title_1,
        titel_2: parsedMissionValue.title_2,
        titel_3: parsedMissionValue.title_3,
        titel_4: parsedMissionValue.title_4,
        text_1: parsedMissionValue.text_1,
        text_2: parsedMissionValue.text_2,
        text_3: parsedMissionValue.text_3,
        text_4: parsedMissionValue.text_4,
      };
    });


    setMission(parsedMission);

    // Filter for only page_group === "Service"
    const HotlineItems = response.data.filter(item => item.page_group === "Hotline");

    // Parse the JSON value string and return usable data
    const parsedHotline = HotlineItems.map(item => {
      let parsedHotlineValue = {};
      try {
        parsedHotlineValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        image: `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`,
        titel_1: parsedHotlineValue.title_1,
        text_1: parsedHotlineValue.text_1,
      };
    });


    setHotline(parsedHotline);


        // Filter for only page_group === "Service"
        const CategoriesItems = response.data.filter(item => item.page_group === "Categories");

        // Parse the JSON value string and return usable data
        const parsedCategories = CategoriesItems.map(item => {
          let parsedCategoriesValue = {};
          try {
            parsedCategoriesValue = JSON.parse(item.value);
          } catch (e) {
            console.error("Error parsing value:", item.value);
          }
    
          return {
            id: item.id,
            title: item.page_part,
            produits: parsedCategoriesValue,
          };
        });
    
    
        setCategories(parsedCategories);


        // Filter for only page_group === "Service"
    const ClassiquesItems = response.data.filter(item => item.page_group === "Classiques");

    // Parse the JSON value string and return usable data
    const parsedClassiques = ClassiquesItems.map(item => {
      let parsedClassiquesValue = {};
      try {
        parsedClassiquesValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        produits: parsedClassiquesValue,
      };
    });


    setClassique(parsedClassiques); 


    // Filter for only page_group === "Service"
    const ProductItems = response.data.filter(item => item.page_group === "Produits");

    // Parse the JSON value string and return usable data
    const parsedProduct = ProductItems.map(item => {
      let parsedProductValue = {};
      try {
        parsedProductValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        produits: parsedProductValue,
      };
    });


    setProduct(parsedProduct); 



    // Filter for only page_group === "Service"
    const serviceItems = response.data.filter(item => item.page_group === "Service");

    // Parse the JSON value string and return usable data
    const parsedServices = serviceItems.map(item => {
      let parsedValue = {};
      try {
        parsedValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        image: `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`,
        titel: parsedValue.Titel,
        description: parsedValue.Description,
        buttonText: parsedValue.Button,
      };
    });

    const Servicetitle = parsedServices.length > 0 ? parsedServices[0].title : null;
    setServicestitle(Servicetitle); 
    setServices(parsedServices); 


      // Filter for only page_group === "Service"
      const CadeauxItems = response.data.filter(item => item.page_group === "Cadeaux");

      // Parse the JSON value string and return usable data
      const parsedCadeaux = CadeauxItems.map(item => {
        let parsedCadeauxValue = {};
        try {
          parsedCadeauxValue = JSON.parse(item.value);
        } catch (e) {
          console.error("Error parsing value:", item.value);
        }
  
        return {
          id: item.id,
          title: item.page_part,
          produits: parsedCadeauxValue,
        };
      });
  
  
      setCadeaux(parsedCadeaux);  setServicestitle(Servicetitle); 
    setServices(parsedServices); setProduct(parsedProduct); setClassique(parsedClassiques); setCategories(parsedCategories);



      // Filter for only page_group === "Service"
      const CelebrationsItems = response.data.filter(item => item.page_group === "Celebrations");

      // Parse the JSON value string and return usable data
      const parsedCelebrations = CelebrationsItems.map(item => {
        let parsedCelebrationsValue = {};
        try {
          parsedCelebrationsValue = JSON.parse(item.value);
        } catch (e) {
          console.error("Error parsing value:", item.value);
        }
  
        return {
          id: item.id,
          title: item.page_part,
          produits: parsedCelebrationsValue,
        };
      });
  
  
      setCelebrations(parsedCelebrations); 


    //setData(response.data);
    localStorage.setItem('imagesfre', JSON.stringify(urls));
    localStorage.setItem('extractedTextsfre', JSON.stringify(extractedTexts));
    localStorage.setItem('servicefre', JSON.stringify(parsedServices));
    localStorage.setItem('Missionfre', JSON.stringify(parsedMission));
    localStorage.setItem('Hotlinefre', JSON.stringify(parsedHotline));
    localStorage.setItem('Productfre', JSON.stringify(parsedProduct)); 
    localStorage.setItem('Celebrationsfre', JSON.stringify(parsedCelebrations)); 
    localStorage.setItem('Cadeauxfre', JSON.stringify(parsedCadeaux)); 
    localStorage.setItem('Servicetitlefre', JSON.stringify(Servicetitle)); 
    localStorage.setItem('Categoriesfre', JSON.stringify(parsedCategories)); 
    localStorage.setItem('Classiquesfre', JSON.stringify(parsedClassiques)); 

  })
  .catch(error => {
    console.error('Error fetching data:', error);
  });
} // Optional: clear data or load French version

  } else {
    const cachedImageseng = JSON.parse(localStorage.getItem('imageseng'));
  const cachedtextseng = JSON.parse(localStorage.getItem('extractedTextseng'));
  const cachedserviceeng = JSON.parse(localStorage.getItem('serviceeng'));
  const cachedMissioneng = JSON.parse(localStorage.getItem('Missioneng'));
  const cachedHotlineeng = JSON.parse(localStorage.getItem('Hotlineeng'));  
  const cachedProducteng = JSON.parse(localStorage.getItem('Producteng'));
  const cachedCelebrationseng = JSON.parse(localStorage.getItem('Celebrationseng'));
  const cachedCadeauxeng = JSON.parse(localStorage.getItem('Cadeauxeng')); 
  const cachedServicetitleeng = JSON.parse(localStorage.getItem('Servicetitleeng')); 
  const cachedCategorieseng = JSON.parse(localStorage.getItem('Categorieseng'));  
  const cachedClassiqueseng = JSON.parse(localStorage.getItem('Classiqueseng')); 
  
  if (cachedImageseng && cachedtextseng && cachedserviceeng && cachedMissioneng && cachedHotlineeng && cachedProducteng && cachedCelebrationseng && cachedCadeauxeng && cachedServicetitleeng && cachedCategorieseng && cachedClassiqueseng) {
    // If images are found in localStorage, use them
    setImages(cachedImageseng);
    setContentArray(cachedtextseng);
    setServices(cachedserviceeng);
    setMission(cachedMissioneng);
    setHotline(cachedHotlineeng);
    setProduct(cachedProducteng);
    setCategories(cachedCategorieseng);
    setClassique(cachedClassiqueseng);
    setCelebrations(cachedCelebrationseng);
    setCadeaux(cachedCadeauxeng);
    setServicestitle(cachedServicetitleeng);
  } else { 
  axios.get(`${process.env.REACT_APP_BACKEND_URL}homeen`)
  .then(response => {

    // Filter only items where page_group === 'Diapositiv'
    const diapositivItems = response.data.filter(item => item.page_group === 'Diapositiv');


    const urls = diapositivItems.map(item =>
      `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`
    );
    const extractedTexts = diapositivItems.map(item => {
      try {
        return JSON.parse(item.value).text + '</br></br><button style="border-radius:5px;">learn more</button>';
      } catch (e) {
        console.error('Failed to parse value:', item.value);
        return '';
      }
    });
    setImages(urls);
    setContentArray(extractedTexts);


    
    // Filter for only page_group === "Service"
    const serviceItems = response.data.filter(item => item.page_group === "Service");

    // Parse the JSON value string and return usable data
    const parsedServices = serviceItems.map(item => {
      let parsedValue = {};
      try {
        parsedValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        image: `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`,
        titel: parsedValue.Titel,
        description: parsedValue.Description,
        buttonText: parsedValue.Button,
      };
    });

    const Servicetitle = parsedServices.length > 0 ? parsedServices[0].title : null;
    setServicestitle(Servicetitle);
    setServices(parsedServices);
    

    
    // Filter for only page_group === "Service"
    const MissionItems = response.data.filter(item => item.page_group === "Mission");

    // Parse the JSON value string and return usable data
    const parsedMission = MissionItems.map(item => {
      let parsedMissionValue = {};
      try {
        parsedMissionValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        image: `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`,
        title: item.page_part,
        titel_1: parsedMissionValue.title_1,
        titel_2: parsedMissionValue.title_2,
        titel_3: parsedMissionValue.title_3,
        titel_4: parsedMissionValue.title_4,
        text_1: parsedMissionValue.text_1,
        text_2: parsedMissionValue.text_2,
        text_3: parsedMissionValue.text_3,
        text_4: parsedMissionValue.text_4,
      };
    });


    setMission(parsedMission);



    // Filter for only page_group === "Service"
    const CategoriesItems = response.data.filter(item => item.page_group === "Categories");

    // Parse the JSON value string and return usable data
    const parsedCategories = CategoriesItems.map(item => {
      let parsedCategoriesValue = {};
      try {
        parsedCategoriesValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        produits: parsedCategoriesValue,
      };
    });


    setCategories(parsedCategories);


    // Filter for only page_group === "Service"
    const ClassiquesItems = response.data.filter(item => item.page_group === "Classiques");

    // Parse the JSON value string and return usable data
    const parsedClassiques = ClassiquesItems.map(item => {
      let parsedClassiquesValue = {};
      try {
        parsedClassiquesValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        produits: parsedClassiquesValue,
      };
    });


    setClassique(parsedClassiques);



    

    // Filter for only page_group === "Service"
    const ProductItems = response.data.filter(item => item.page_group === "Produits");

    // Parse the JSON value string and return usable data
    const parsedProduct = ProductItems.map(item => {
      let parsedProductValue = {};
      try {
        parsedProductValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        produits: parsedProductValue,
      };
    });


    setProduct(parsedProduct);



    // Filter for only page_group === "Service"
    const HotlineItems = response.data.filter(item => item.page_group === "Hotline");

    // Parse the JSON value string and return usable data
    const parsedHotline = HotlineItems.map(item => {
      let parsedHotlineValue = {};
      try {
        parsedHotlineValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        image: `https://colorixfrontend.seuytel.com/${item.image_url.replace('./', '/')}`,
        titel_1: parsedHotlineValue.title_1,
        text_1: parsedHotlineValue.text_1,
      };
    });


    setHotline(parsedHotline);

    // Filter for only page_group === "Service"
    const CadeauxItems = response.data.filter(item => item.page_group === "Cadeaux");

    // Parse the JSON value string and return usable data
    const parsedCadeaux = CadeauxItems.map(item => {
      let parsedCadeauxValue = {};
      try {
        parsedCadeauxValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        produits: parsedCadeauxValue,
      };
    });


    setCadeaux(parsedCadeaux);



    // Filter for only page_group === "Service"
    const CelebrationsItems = response.data.filter(item => item.page_group === "Celebrations");

    // Parse the JSON value string and return usable data
    const parsedCelebrations = CelebrationsItems.map(item => {
      let parsedCelebrationsValue = {};
      try {
        parsedCelebrationsValue = JSON.parse(item.value);
      } catch (e) {
        console.error("Error parsing value:", item.value);
      }

      return {
        id: item.id,
        title: item.page_part,
        produits: parsedCelebrationsValue,
      };
    });


    setCelebrations(parsedCelebrations);


    //setData(response.data);
    localStorage.setItem('imageseng', JSON.stringify(urls));
    localStorage.setItem('extractedTextseng', JSON.stringify(extractedTexts));
    localStorage.setItem('serviceeng', JSON.stringify(parsedServices));
    localStorage.setItem('Missioneng', JSON.stringify(parsedMission));
    localStorage.setItem('Hotlineeng', JSON.stringify(parsedHotline));
    localStorage.setItem('Producteng', JSON.stringify(parsedProduct));
    localStorage.setItem('Celebrationseng', JSON.stringify(parsedCelebrations)); 
    localStorage.setItem('Cadeauxeng', JSON.stringify(parsedCadeaux)); 
    localStorage.setItem('Servicetitleeng', JSON.stringify(Servicetitle)); 
    localStorage.setItem('Categorieseng', JSON.stringify(parsedCategories)); 
    localStorage.setItem('Classiqueseng', JSON.stringify(parsedClassiques)); 
  })
  .catch(error => {
    console.error('Error fetching data:', error);
  });
}

  }
}, [language]);



  const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
  const isTablet = useMediaQuery({ query: '(max-width: 1024px)' });
  const [imageSrc, setImageSrc] = useState(icon); // Default image

  //add the foreground when a menuItem is clicked
  const {isForeGround} = useContext(ForeGroundContext);
  const changeImagesrc = () => {
    setImageSrc(icon); // New image on hover
  };
  const setupImagesrc = () => {
    setImageSrc(icon); // Reset to default image
  };
  // Function to change image on hover
  const changeImagesrc1 = () => {
    setImageSrc(icon2); // New image on hover
  };
  const setupImagesrc1 = () => {
    setImageSrc(icon2); // Reset to default image
  };

  // Function to change image on hover
  const changeImagesrc2 = () => {
    setImageSrc(icon3); // New image on hover
  };
  const setupImagesrc2 = () => {
    setImageSrc(icon3); // Reset to default image
  };
  // Function to change image on hover
  const changeImagesrc3 = () => {
    setImageSrc(icon4); // New image on hover
  };

  const setupImagesrc3 = () => {
    setImageSrc(icon4); // Reset to default image
  };

    // Function to change image on hover
    const changeImagesrc4 = () => {
      setImageSrc(icon5); // New image on hover
    };
  
    const setupImagesrc4 = () => {
      setImageSrc(icon5); // Reset to default image
    };

      // Function to change image on hover
  const changeImagesrc5 = () => {
    setImageSrc(icon6); // New image on hover
  };

  const setupImagesrc5 = () => {
    setImageSrc(icon6); // Reset to default image
  };

    // Function to change image on hover
    const changeImagesrc6 = () => {
      setImageSrc(icon7); // New image on hover
    };
  
    const setupImagesrc6 = () => {
      setImageSrc(icon7); // Reset to default image
    };

      // Function to change image on hover
  const changeImagesrc7 = () => {
    setImageSrc(icon8); // New image on hover
  };

  const setupImagesrc7 = () => {
    setImageSrc(icon8); // Reset to default image
  };

    // Function to change image on hover
    const changeImagesrc8 = () => {
      setImageSrc(icon9); // New image on hover
    };
  
    const setupImagesrc8 = () => {
      setImageSrc(icon9); // Reset to default image
    };

      // Function to change image on hover
  const changeImagesrc9 = () => {
    setImageSrc(icon10); // New image on hover
  };

  const setupImagesrc9 = () => {
    setImageSrc(icon10); // Reset to default image
  };

    // Function to change image on hover
    const changeImagesrc10 = () => {
      setImageSrc(icon11); // New image on hover
    };
  
    const setupImagesrc10 = () => {
      setImageSrc(icon11); // Reset to default image
    };

      // Function to change image on hover
  const changeImagesrc11 = () => {
    setImageSrc(icon12); // New image on hover
  };

  const setupImagesrc11 = () => {
    setImageSrc(icon12); // Reset to default image
  };

    
  const [backgroundColor, setBackgroundColor] = useState('#d3d3d3');
  const changeBackgroundColor = () => {
    setBackgroundColor('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor = () => {
    setBackgroundColor('#d3d3d3'); // Save the color after hover
  };
  const [backgroundColor1, setBackgroundColor1] = useState('white');
  const changeBackgroundColor1 = () => {
    setBackgroundColor1('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor1 = () => {
    setBackgroundColor1('#d3d3d3'); // Save the color after hover
  };
  const [backgroundColor2, setBackgroundColor2] = useState('white');
  const changeBackgroundColor2 = () => {
    setBackgroundColor2('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor2 = () => {
    setBackgroundColor2('#d3d3d3'); // Save the color after hover
  };
  const [backgroundColor3, setBackgroundColor3] = useState('white');
  const changeBackgroundColor3 = () => {
    setBackgroundColor3('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor3 = () => {
    setBackgroundColor3('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor4, setBackgroundColor4] = useState('white');
  const changeBackgroundColor4 = () => {
    setBackgroundColor4('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor4 = () => {
    setBackgroundColor4('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor5, setBackgroundColor5] = useState('white');
  const changeBackgroundColor5 = () => {
    setBackgroundColor5('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor5 = () => {
    setBackgroundColor5('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor6, setBackgroundColor6] = useState('white');
  const changeBackgroundColor6 = () => {
    setBackgroundColor6('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor6 = () => {
    setBackgroundColor6('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor7, setBackgroundColor7] = useState('white');
  const changeBackgroundColor7 = () => {
    setBackgroundColor7('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor7 = () => {
    setBackgroundColor7('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor8, setBackgroundColor8] = useState('white');
  const changeBackgroundColor8 = () => {
    setBackgroundColor8('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor8 = () => {
    setBackgroundColor8('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor9, setBackgroundColor9] = useState('white');
  const changeBackgroundColor9 = () => {
    setBackgroundColor9('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor9 = () => {
    setBackgroundColor9('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor10, setBackgroundColor10] = useState('white');
  const changeBackgroundColor10 = () => {
    setBackgroundColor10('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor10 = () => {
    setBackgroundColor10('#d3d3d3'); // Save the color after hover
  };

  const [backgroundColor11, setBackgroundColor11] = useState('white');
  const changeBackgroundColor11 = () => {
    setBackgroundColor11('#d3d3d3'); // Change background on hover
  };
  // Handle mouse leave (save color)
  const setupBackgroundColor11 = () => {
    setBackgroundColor11('#d3d3d3'); // Save the color after hover
  };
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);
  const [isHovered5, setIsHovered5] = useState(false);
  const [isHovered6, setIsHovered6] = useState(false);
  const [isHovered7, setIsHovered7] = useState(false);
  const [isHovered8, setIsHovered8] = useState(false);
  const [isHovered9, setIsHovered9] = useState(false);
  const [isHovered10, setIsHovered10] = useState(false);
  const [isHovered11, setIsHovered11] = useState(false);

  const reset = () => {
    setBackgroundColor('white');
    setBackgroundColor1('white');
    setBackgroundColor2('white');
    setBackgroundColor3('white');
    setBackgroundColor4('white');
    setBackgroundColor5('white');
    setBackgroundColor6('white');
    setBackgroundColor7('white');
    setBackgroundColor8('white');
    setBackgroundColor9('white');
    setBackgroundColor10('white');
    setBackgroundColor11('white');

  }
  const handleHoverEnter = () => {
    setIsHovered(true);
    reset();  
    changeBackgroundColor(); // Run the first event
    changeImagesrc(); // Run the second event
  };
  const handleHoverLeave = () => {
    setIsHovered(false);
    setupBackgroundColor(); // Run the first event
    setupImagesrc(); // Run the second event
  };
  const handleHoverEnter1 = () => {
    setIsHovered1(true);
    reset();    
    changeBackgroundColor1(); // Run the first event
    changeImagesrc1(); // Run the second event
  };
  const handleHoverLeave1 = () => {
    setIsHovered1(false);
    setupBackgroundColor1(); // Run the first event
    setupImagesrc1(); // Run the second event
  };
  // Function to change image on hover
  const handleHoverEnter2 = () => {
    setIsHovered2(true);
    reset();    
    changeBackgroundColor2(); // Run the first event
    changeImagesrc2(); // Run the second event
  };

  const handleHoverLeave2 = () => {
    setIsHovered2(false);
    setupBackgroundColor2(); // Run the first event
    setupImagesrc2(); // Run the second event
  };

  // Function to change image on hover
  const handleHoverEnter3 = () => {
    setIsHovered3(true);
    reset();    
    changeBackgroundColor3(); // Run the first event
    changeImagesrc3(); // Run the second event
  };

  const handleHoverLeave3 = () => {
    setIsHovered3(false);
    setupBackgroundColor3(); // Run the first event
    setupImagesrc3(); // Run the second event
  };
  // Function to change image on hover
  const handleHoverEnter4 = () => {
    setIsHovered4(true);
    reset();    
    changeBackgroundColor4(); // Run the first event
    changeImagesrc4(); // Run the second event
  };

  const handleHoverLeave4 = () => {
    setIsHovered4(false);
    setupBackgroundColor4(); // Run the first event
    setupImagesrc4(); // Run the second event
  };   
  
    // Function to change image on hover
    const handleHoverEnter5 = () => {
      setIsHovered5(true);
      reset();    
      changeBackgroundColor5(); // Run the first event
      changeImagesrc5(); // Run the second event
    };
  
    const handleHoverLeave5 = () => {
      setIsHovered5(false);
      setupBackgroundColor5(); // Run the first event
      setupImagesrc5(); // Run the second event
    };  

      // Function to change image on hover
  const handleHoverEnter6 = () => {
    setIsHovered6(true);
    reset();    
    changeBackgroundColor6(); // Run the first event
    changeImagesrc6(); // Run the second event
  };

  const handleHoverLeave6 = () => {
    setIsHovered6(false);
    setupBackgroundColor6(); // Run the first event
    setupImagesrc6(); // Run the second event
  };  

    // Function to change image on hover
    const handleHoverEnter7 = () => {
      setIsHovered7(true);
      reset();    
      changeBackgroundColor7(); // Run the first event
      changeImagesrc7(); // Run the second event
    };
  
    const handleHoverLeave7 = () => {
      setIsHovered7(false);
      setupBackgroundColor7(); // Run the first event
      setupImagesrc7(); // Run the second event
    };  
      

    // Function to change image on hover
    const handleHoverEnter8 = () => {
      setIsHovered8(true);
      reset();    
      changeBackgroundColor8(); // Run the first event
      changeImagesrc8(); // Run the second event
    };
  
    const handleHoverLeave8 = () => {
      setIsHovered8(false);
      setupBackgroundColor8(); // Run the first event
      setupImagesrc8(); // Run the second event
    };  
  
  
      // Function to change image on hover
      const handleHoverEnter9 = () => {
        setIsHovered9(true);
        reset();    
        changeBackgroundColor9(); // Run the first event
        changeImagesrc9(); // Run the second event
      };
    
      const handleHoverLeave9 = () => {
        setIsHovered9(false);
        setupBackgroundColor9(); // Run the first event
        setupImagesrc9(); // Run the second event
      };  
  
      
          // Function to change image on hover
    const handleHoverEnter10 = () => {
      setIsHovered10(true);
      reset();    
      changeBackgroundColor10(); // Run the first event
      changeImagesrc10(); // Run the second event
    };
  
    const handleHoverLeave10 = () => {
      setIsHovered10(false);
      setupBackgroundColor10(); // Run the first event
      setupImagesrc10(); // Run the second event
    };  
  

        // Function to change image on hover
        const handleHoverEnter11 = () => {
          setIsHovered11(true);
          reset();    
          changeBackgroundColor11(); // Run the first event
          changeImagesrc11(); // Run the second event
        };
      
        const handleHoverLeave11 = () => {
          setIsHovered11(false);
          setupBackgroundColor11(); // Run the first event
          setupImagesrc11(); // Run the second event
        };  
  

        
  // State to hold the current image index
  const [imageIndex, setImageIndex] = useState(0);
  const [redDivIndex, setRedDivIndex] = useState(0);

  // Array of image URLs
  /*const images = [
    icon,
    icon2,
    icon3,
    icon4,
    icon5,
    icon6,
    icon7,
    icon8,
    icon9,
    icon10,
    icon11,
    icon12
  ];*/
  const [contentIndex, setContentIndex] = useState(0); // Index to track current content
  /*const contentArray = [
    'Imprimer vos affiches sur tous formats, de A1 a A4  </br> </br> <button style="border-radius:5px;"> en savoir plus </button>',
    'Concevez vos Flyers suivant le format de votre choix',
    'Imprimer vos calendriers suivant votre design ',
    "Solutions d'impression  signaletique ",
   'Imprimer vos affiches sur tous formats, de A1 a A4 ',
    'Concevez vos Flyers suivant le format de votre choix ',
    'Imprimer vos calendriers suivant votre design ',
    "Solutions d'impression  signaletique ",
    'Imprimer vos affiches sur tous formats, de A1 a A4 ',
    'Concevez vos Flyers suivant le format de votre choix ',
    'Imprimer vos calendriers suivant votre design ',
    "Solutions d'impression  signaletique ",
    ];*/
  // Change the image every 5 seconds
  useEffect(() => {

    if (isHovered) return setImageIndex(0), 
    setRedDivIndex(0),
    setContentIndex(0);
    else if (isHovered1) return setImageIndex(1), 
    setRedDivIndex(1),
    setContentIndex(1);
    else if (isHovered2) return setImageIndex(2), 
    setRedDivIndex(2),
    setContentIndex(2);
    else if (isHovered3) return setImageIndex(3), 
    setRedDivIndex(3),
    setContentIndex(3);
    else if (isHovered4) return setImageIndex(4), 
    setRedDivIndex(4),
    setContentIndex(4);
    else if (isHovered5) return setImageIndex(5), 
    setRedDivIndex(5),
    setContentIndex(5);
    else if (isHovered6) return setImageIndex(6), 
    setRedDivIndex(6),
    setContentIndex(6);
    else if (isHovered7) return setImageIndex(7), 
    setRedDivIndex(7),
    setContentIndex(7);
    else if (isHovered8) return setImageIndex(8), 
    setRedDivIndex(8),
    setContentIndex(8);
    else if (isHovered9) return setImageIndex(9), 
    setRedDivIndex(9),
    setContentIndex(9);
    else if (isHovered10) return setImageIndex(10), 
    setRedDivIndex(10),
    setContentIndex(10);
    else if (isHovered11) return setImageIndex(11), 
    setRedDivIndex(11),
    setContentIndex(11);
    const intervalId = setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setRedDivIndex((prevIndex) => (prevIndex + 1) % 12);
      setContentIndex(prevIndex => (prevIndex + 1) % contentArray.length);
    }, 5000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [images.length, isHovered, isHovered1, isHovered2, isHovered3, isHovered4, isHovered5, isHovered6, isHovered7, isHovered8, isHovered9, isHovered10, isHovered11]);
  

  const scrollRef = useRef(null);

  const scrollByDirection = (direction) => {
    const scrollAmount = direction === 'left' ? -200 : 200;
    scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  const scrollRef1 = useRef(null);

  const scrollByDirection1 = (direction) => {
    const scrollAmount1 = direction === 'left' ? -200 : 200;
    scrollRef1.current.scrollBy({ left: scrollAmount1, behavior: 'smooth' });
  };

  const scrollRef2 = useRef(null);

  const scrollByDirection2 = (direction) => {
    const scrollAmount2 = direction === 'left' ? -200 : 200;
    scrollRef2.current.scrollBy({ left: scrollAmount2, behavior: 'smooth' });
  };

  const scrollRef3 = useRef(null);

  const scrollByDirection3 = (direction) => {
    const scrollAmount3 = direction === 'left' ? -200 : 200;
    scrollRef3.current.scrollBy({ left: scrollAmount3, behavior: 'smooth' });
  };

/*
  const [isHover, setIsHover] = useState(false);
  const [isHover1, setIsHover1] = useState(false);
  const [isHover2, setIsHover2] = useState(false);
  const [isHover3, setIsHover3] = useState(false);
  const [isHover4, setIsHover4] = useState(false);
  const [isHover5, setIsHover5] = useState(false);
  
*/

const [hoveredStaticIndex, setHoveredStaticIndex] = useState(null);


  return (
    
  <div id="alldivs" className={`${isForeGround? 'scroll-disabling' : '' }`} style={{ marginTop:'70px' }}>

      <div id="firsthead" style={{borderBottom: '2px solid black'}}>

          <div className="head-image" style={{borderBottom: '2px solid black', position:'relative',backgroundImage: `url(${images[imageIndex]})`,backgroundSize: 'cover', backgroundPosition: 'center',transition: 'opacity 0.3s ease, transform 0.3s ease'}}>    
          <div className="imageoverlay" style={{
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
 /* backgroundColor: '#4CAF50',*/
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '15px',
  textAlign: 'center',
  /* width: '35vw',  // 50% de la largeur de l'écran
  height: '55vh', // 30% de la hauteur de l'écran*/
  padding: '10px', // Meilleur espacement
}}>
  <span style={{ paddingTop: '0px', paddingBottom: '0px' }} dangerouslySetInnerHTML={{ __html: contentArray[contentIndex] }}/>
</div>
             {/* <div className="sub-image" style={{position: 'absolute',top: '20%',left: '5%', transform: 'translate(-5%, -5%)',display: 'inline-block',padding: '10px', border: '0px solid #ccc', wordWrap: 'break-word', width: 'auto',}}>        
               <span style={{backgroundColor: 'white', paddingTop: '10px', paddingBottom: '10px'}} dangerouslySetInnerHTML={{ __html: contentArray[contentIndex] }}/>
              </div>
             */}
          </div>

           
          <Row className="g-2" id="coldivs" style={{width: '100%',position: 'absolute',marginTop: '-138px',marginLeft: '0px',}} >
            {/*  <Col class="" style={{marginLeft: '0px'}}>
                  <div class="coldes" key={0} style={{backgroundColor: redDivIndex === 0 ? '#d3d3d3' : 'white',height: '130px'}} onMouseEnter={handleHoverEnter} onMouseLeave={handleHoverLeave}>
                    <h4>Optimieren Sie Ihre Online-Präsenz
                      {films.map((fi) => (  
                            <div key={fi.id}>
                            {fi.id} - {fi.url}
                          </div>
                        ))} 
                        </h4> 
                    <div className="bottom-text">
                     <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="" style={{marginLeft: '0px'}} > 
                  <div class="coldes" key={1} style={{backgroundColor: redDivIndex === 1 ? '#d3d3d3' : 'white',height: '130px'}} onMouseEnter={handleHoverEnter1} onMouseLeave={handleHoverLeave1} >
                    <h4>Optimieren Sie die IT Strukur Ihrer Firma</h4> 
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="" style={{marginLeft: '0px'}}> 
                  <div class="coldes" key={2} style={{ backgroundColor: redDivIndex === 2 ? '#d3d3d3' : 'white', height: '130px' }} onMouseEnter={handleHoverEnter2} onMouseLeave={handleHoverLeave2}>
                    <h4>Automatisieren Sie Ihre Anwendungen</h4> 
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={3} style={{ backgroundColor: redDivIndex === 3 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter3} onMouseLeave={handleHoverLeave3}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={4} style={{ backgroundColor: redDivIndex === 4 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter4} onMouseLeave={handleHoverLeave4}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={5} style={{ backgroundColor: redDivIndex === 5 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter5} onMouseLeave={handleHoverLeave5}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={6} style={{ backgroundColor: redDivIndex === 6 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter6} onMouseLeave={handleHoverLeave6}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={7} style={{ backgroundColor: redDivIndex === 7 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter7} onMouseLeave={handleHoverLeave7}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={8} style={{ backgroundColor: redDivIndex === 8 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter8} onMouseLeave={handleHoverLeave8}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={9} style={{ backgroundColor: redDivIndex === 9 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter9} onMouseLeave={handleHoverLeave9}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={10} style={{ backgroundColor: redDivIndex === 10 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter10} onMouseLeave={handleHoverLeave10}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              <Col class="pe-0 ps-0 pl-0 pr-0" style={{marginLeft: '0px'}}> 
                  <div className="coldes" key={11} style={{ backgroundColor: redDivIndex === 11 ? '#d3d3d3' : 'white', height: '130px', marginRight: '0px', width:'100%'}} onMouseEnter={handleHoverEnter11} onMouseLeave={handleHoverLeave11}>
                    <h4>Lösen Sie Ihre IT-Probleme </h4>
                    <div className="bottom-text">
                      <a href="">en savoir plus</a>
                    </div>
                  </div>
              </Col>
              */}
              <div class="colpoints" style={{textAlign: 'center', marginTop:'100px'}}>
                <div class="divpoint" style={{backgroundColor:'white'}}>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 0 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter} onMouseLeave={handleHoverLeave}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',   color: redDivIndex === 1 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter1} onMouseLeave={handleHoverLeave1}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 2 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter2} onMouseLeave={handleHoverLeave2}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer', color: redDivIndex === 3 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter3} onMouseLeave={handleHoverLeave3}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 4 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter4} onMouseLeave={handleHoverLeave4}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 5 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter5} onMouseLeave={handleHoverLeave5}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 6 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter6} onMouseLeave={handleHoverLeave6}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 7 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter7} onMouseLeave={handleHoverLeave7}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',   color: redDivIndex === 8 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter8} onMouseLeave={handleHoverLeave8}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 9 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter9} onMouseLeave={handleHoverLeave9}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer',  color: redDivIndex === 10 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter10} onMouseLeave={handleHoverLeave10}>.</p>
                  <p class="point" style={{display:'inline-block', cursor:'pointer', color: redDivIndex === 11 ? 'red' : 'black',}}  onMouseEnter={handleHoverEnter11} onMouseLeave={handleHoverLeave11}>.</p>
                </div>
              </div>
             

          </Row>
  

      </div>
      
      {/*  <Container style={{marginBottom: '30px'}}> 
            <div className="sub-image" style={{position: 'relative', display: 'inline-block',padding: '10px', border: '0px solid #ccc', wordWrap: 'break-word', width: 'auto',}}>        
               <span style={{backgroundColor: 'white', paddingTop: '0px', paddingBottom: '0px'}} dangerouslySetInnerHTML={{ __html: contentArray[contentIndex] }}/>
            </div>
          </Container> 
      */}
      <Container class="mt-4" >
      <div className="scroll-container-wrapper ">
      {categories.map((categorie, categorieIndex) => (
        <h2 class="mt-5">{categorie.title}</h2>
      ))}
        <div className="scroll-wrapper">
        <div className="scroll-btn scroll-left" onClick={() => scrollByDirection1('left')}>←</div>

        <div className="scroll-content" ref={scrollRef1}>
        {categories.map((categorieGroup, groupIndex) => (
        categorieGroup.produits.map((categorie, index) => (
        <div className="scroll-item" key={index}>
        <div className="circle-item">
        <img src={categorie.image} alt={`icon${index}`} className="circle-image" />
        <div className="item-title">{categorie.categorie}</div>
        </div>
        </div>
        ))
        ))}
        </div>

        <div className="scroll-btn scroll-right" onClick={() => scrollByDirection1('right')}>→</div>
        </div>
      </div>
      </Container>

      <div style={{backgroundColor: '#f1f1f1', width:'100%',height: 'auto', marginTop: '30px'}}>
        <Container class="mt-5 pt-4 pb-5" style={{position: 'relative', backgroundColor: '#f1f1f1'}}>
       
      {classiques.map((classique, categorieIndex) => (
        <h2  style={{paddingTop: '40px'}}>{classique.title}</h2>
      ))}
        <Row className=' pb-5' style={{backgroundColor: '#f1f1f1'}}>
        {classiques.map((classiqueGroup, groupIndex) => (
        classiqueGroup.produits.map((classique, index) => (
          <div class="col-6 col-md-4 mt-3 mt-md-5" style={{backgroundColor: '#f1f1f1', paddingLeft: '10px', paddingRight: '20px', textAlign: 'center'}}>
            <div className='divhauptleistung' style={{position: 'relative', backgroundColor: hoveredStaticIndex === index ? '#d3d1d0' : 'white', border: '0.5px solid white', borderRadius: '20px', paddingBottom: '20px', paddingRight: '10px', paddingLeft: '10px', paddingTop: '10px', width:'100%', textAlign: 'center', cursor: 'pointer'}} onMouseEnter={() => setHoveredStaticIndex(index)} onMouseLeave={() => setHoveredStaticIndex(null)}>
              <img src={classique.image} alt={`icon1`} className="circle-image-cat"/>
              <p className='phauptleistung' style={{fontWeight: '500'}}></p>
               <p class="mt-5"> <a className=' mt-2 phauptleistung' href="" style={{color: '#0031bb', fontWeight: '500', textDecoration: 'none'}}> {classique.classique}  </a></p>
            </div>
          </div>
          ))
        ))}
         
        </Row>
        </Container>
      </div>
      <Container >
      <div className="scroll-container-wrapper">
      {products.map((group, groupIndex) => (
        <h2 class="mt-5">{group.title}</h2>
      ))}
        <div className="scroll-wrapper">
        <div className="scroll-btn scroll-left" onClick={() => scrollByDirection('left')}>←</div>

        <div className="scroll-content" ref={scrollRef}>
        {products.map((productGroup, groupIndex) => (
        productGroup.produits.map((product, index) => (
        <div className="scroll-item" key={index}>
        <div className="circle-item">
        <img src={product.image} alt={`icon${index}`} className="circle-image" />
        <div className="item-title">{product.produit}</div>
        </div>
        </div>
        ))
        ))}
        </div>

        <div className="scroll-btn scroll-right" onClick={() => scrollByDirection('right')}>→</div>
        </div>

      </div>
      </Container>
      <div style={{backgroundColor: '#f1f1f1', width:'100%',height: 'auto', marginTop: '40px'}}>
        <Container style={{paddingTop: '30px'}}> 
        
          <h3>{servicestitle}</h3>
       
          <Row style={{marginTop: '30px', paddingBottom: '50px'}}>
           
            {services.map(service => (
               <div class="col-12 col-md-4 mt-1 mt-lg-0 mb-5 mb-xl-0" style={{paddingRight: '20px'}}>
              <img class="imgbeliebt" src={service.image} alt={service.titel} style={{width: '100%'}} />
              <h5 style={{marginTop: '20px', fontWeight: 'bold'}}>{service.titel}</h5>
              <p class="mt-3">{service.description}</p>
              <button class="mt-3 mt-md-4" style={{padding: '10px', border: '0.5px solid gray'}}><b>{service.buttonText}</b></button>
            </div>
            ))}
            
          </Row>
        </Container>
      </div >
      <Container >
      <div className="scroll-container-wrapper">
      {cadeaux.map((group, groupIndex) => (
        <h2 class="mt-5">{group.title}</h2>
      ))}
        <div className="scroll-wrapper">
        <div className="scroll-btn scroll-left" onClick={() => scrollByDirection2('left')}>←</div>

        <div className="scroll-content" ref={scrollRef2}>
        {cadeaux.map((cadeauxGroup, groupIndex) => (
        cadeauxGroup.produits.map((cadeau, index) => (
        <div className="scroll-item" key={index}>
        <div className="circle-item">
        <img src={cadeau.image} alt={`icon${index}`} className="circle-image" />
        <div className="item-title">{cadeau.cadeaux}</div>
        </div>
        </div>
        ))
        ))}
        </div>

        <div className="scroll-btn scroll-right" onClick={() => scrollByDirection2('right')}>→</div>
        </div>

      </div>
      </Container>

      <div style={{backgroundColor: '#f1f1f1', width:'100%',height: 'auto', marginTop: '70px', paddingTop: '20px', paddingBottom: '80px'}}>
      <Container >
      <div className="scroll-container-wrapper">
      {celebrations.map((group, groupIndex) => (
        <h2 class="mt-5">{group.title}</h2>
      ))}
        <div className="scroll-wrapper">
        <div className="scroll-btn scroll-left" onClick={() => scrollByDirection3('left')}>←</div>

        <div className="scroll-content" ref={scrollRef3}>
        {celebrations.map((celebrationsGroup, groupIndex) => (
        celebrationsGroup.produits.map((celebration, index) => (
        <div className="scroll-item1" key={index}>
        <div className="circle-item">
        <img src={celebration.image} alt={`icon${index}`} className="circle-image" />
        <div className="item-title">{celebration.celebration}</div>
        </div>
        </div>
        ))
        ))}
        </div>

        <div className="scroll-btn scroll-right" onClick={() => scrollByDirection3('right')}>→</div>
        </div>

      </div>
      </Container>
      </div>
      <div >
        
          <Container className="mt-5" >
          {missions.map(mission => (
          <h3 className='h3itpartner'> {mission.title} </h3>
          ))}
          <Row>
          {missions.map(mission => (
              <div class="col-12 col-lg-5 mt-3" >
              <img
                    className="d-block w-100 mt-lg-3" src={mission.image} alt="Third slide" style={{borderRadius: '20px'}} />
              </div>
              ))} 
              {missions.map((mission, index) => (
              <div class="col-12 col-lg-7 mt-3" key={index}>
                <h4 class="mt-4" className='h4itpartner' >{mission.titel_1} </h4>
                <p className='phauptleistung'>{mission.text_1}</p>
                <h4 class="mt-4 mt-lg-5"  className='h4itpartner' >{mission.titel_2}</h4>
                <p className='phauptleistung'>{mission.text_2}</p>
                <h4 class="mt-4 mt-lg-5" className='h4itpartner' >{mission.titel_3}</h4>
                <p className='phauptleistung' dangerouslySetInnerHTML={{ __html: mission.text_3 }} />
                <h4 class="mt-4 mt-lg-5" className='h4itpartner' >{mission.titel_4}
                </h4>
                <p className='phauptleistung'> {mission.text_4} </p>              
              </div>
            ))} 
            {hotlines.map(hotline => (
              <div class="col-6 mt-5 mb-5">
              
              <img
                    className="d-block hotlimg" src={hotline.image} alt="Third slide" style={{borderRadius: '20px', height: 'auto'}} />
                {/*<h5 className='h5itpartner' >+237 699 888 577</h5>
                <p className='phauptleistung'>Hotline <br/>09h00-1300 <br/>14h00-18h30</p>*/}
              
              </div>
            ))} 
            {hotlines.map((hotline, index) => (
            <div className="col-6 mt-5" key={index}>
            <h5 className="h5itpartner">{hotline.title_1}</h5>
            <p
            className="phauptleistung"
            dangerouslySetInnerHTML={{ __html: hotline.text_1 }}
            />
            </div>
            ))}

            </Row>

        
          </Container>
   
      </div>
  </div>
        
    );
}

export default HomeComponent;